import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
import { trackAddToCart } from '../../lib/pixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  pulse?: boolean;
  href?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO ROMPER MIS CADENAS HOY',
  className = '',
  onClick,
  pulse = false,
  href
}: CTAButtonProps) {
  const isExternal = !!href;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
      return;
    }
    if (!isExternal) {
      e.preventDefault();
      const priceCard = document.getElementById('price-card');
      if (priceCard) {
        priceCard.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      trackAddToCart();
    }
  };
  const button = <motion.a href={href || '#price-card'} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`
        relative inline-flex items-center justify-center gap-2 w-full md:w-auto text-center
        bg-gold hover:bg-gold-dark text-charcoal font-bold 
        py-4 px-8 md:px-10 rounded-full shadow-lg
        transition-colors duration-300
        text-xs md:text-base tracking-wide uppercase
        border-2 border-gold-dark/30
        ${className}
      `} data-id="element-212">
      <Shield size={18} className="shrink-0 hidden md:block" data-id="element-213" />
      <span className="leading-tight text-center" data-id="element-214">{text}</span>
    </motion.a>;
  if (!pulse) return button;
  return <div className="relative inline-flex items-center justify-center w-full md:w-auto" data-id="element-215">
      {/* Golden glow pulse rings */}
      <motion.div className="absolute inset-0 rounded-full bg-gold/20" animate={{
      scale: [1, 1.15, 1],
      opacity: [0.4, 0, 0.4]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-216" />
      <motion.div className="absolute inset-0 rounded-full bg-gold/15" animate={{
      scale: [1, 1.25, 1],
      opacity: [0.3, 0, 0.3]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.3
    }} data-id="element-217" />
      {/* Heartbeat animation on the button itself */}
      <motion.div animate={{
      scale: [1, 1.04, 1, 1.02, 1]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="relative z-10 w-full md:w-auto" data-id="element-218">
        {button}
      </motion.div>
    </div>;
}